import { getWindow } from '@surfline/web-common';

export const postMessageToNativeApp = (handlerName: string, data?: any): void => {
  const window = getWindow() as any;
  if (window?.webkit === undefined && window?.SurflineAndroid === undefined) {
    return;
  }

  if (window?.webkit) {
    const handler = window.webkit?.messageHandlers[handlerName];
    if (handler !== undefined) {
      handler.postMessage(data);
    }
  } else if (window?.SurflineAndroid) {
    if (
      handlerName === 'onForecastContentShare' &&
      typeof window?.SurflineAndroid?.shareForecast === 'function'
    ) {
      // Special case for forecast sharing
      window?.SurflineAndroid?.shareForecast(JSON.stringify(data));
    } else if (typeof window?.SurflineAndroid?.[handlerName] === 'function') {
      /*
        Assigning this to a vaiable like above on IOS causes issues with the
        value of "this" when its called within android
      */
      const dataStr = typeof data === 'boolean' ? data : JSON.stringify(data);

      window?.SurflineAndroid?.[handlerName](dataStr);
    }
  }
};

export default postMessageToNativeApp;
